<template>
  <div class="ticker">
    <span v-if="paused" @click="togglePause"><i class="fas fa-pause"></i> Paused</span>
    <span v-if="!paused && ticker > 2" @click="togglePause">{{ ticker }} secs</span>
    <span v-if="!paused && ticker <= 2" @click="togglePause">
      &hellip;
    </span>
    &nbsp;<i class="fas fa-sync-alt" @click="refresh"></i>
  </div>
</template>

<script>
export default {
  props: ['interval'],
  data() {
    return {
      ticker: 0,
      paused: false,
    };
  },
  mounted() {
    this.ticker = this.interval;
    setInterval(() => {
      if (this.paused) {
        return;
      }
      this.ticker = this.ticker -= 1;
      if (this.ticker <= 0) {
        this.$emit('tickerReachedZero');
        this.ticker = this.interval;
      }
    }, 1000);
  },
  methods: {
    togglePause() {
      this.paused = !this.paused;
    },
    refresh() {
      this.ticker = 1;
      this.paused = false;
    }
  },
};
</script>
